import { FC } from "react";
import { useResourceRegister } from "~/utils/resourceRegister";

const SecureFilesResourceRegister: FC = () => {
  useResourceRegister({ name: 'secure-files/dashboard' })
  useResourceRegister({ name: 'secure-files/file-catalog' })
  useResourceRegister({ name: 'secure-files/file-access-log' })
  useResourceRegister({ name: 'secure-files' })
  useResourceRegister({ name: 'secure-files-instances' })
  useResourceRegister({ name: 'secure-files-tags' })
  useResourceRegister({ name: 'secure-files-dashboard' })
  return ( null )
}

export default SecureFilesResourceRegister;